export const PHONE_NUMBER_REGEXP = /^\+\d{2,3}[\s]?\d{8,11}$/;
export const POSTAL_CODE_REGEXP = /^\d{3}[\s]?\d{2}$/;
